export default from './PhotoBanner';



/** WEBPACK FOOTER **
 ** ./app/components/photoBanner/index.js
 **/